import React from 'react'
import { ConfirmDialog } from '@wove/web-ui'

interface DeleteConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  onConfirm: () => void
  isDeleting?: boolean
}

export default function DeleteConfirmationDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  isDeleting = false,
}: DeleteConfirmationDialogProps) {
  return (
    <ConfirmDialog
      isOpen={open}
      handleClose={() => onOpenChange(false)}
      title={title}
      message={description}
      action={{
        label: isDeleting ? 'Deleting...' : 'Delete',
        onClick: onConfirm,
        loading: isDeleting,
      }}
    />
  )
}